<div class="modal-header">
    <h3 class="modal-title">{{ displayName }}</h3>
    <div class="header-actions">
        <i class="fa"
           [ngClass]="{'fa-plus-square-o': minimised, 'fa-minus-square-o': !minimised}"
           style="margin-right: 10px; cursor: pointer;"
           (click)="toggleMinimise()"></i>
        <i class="fa fa-times" style="cursor: pointer;" (click)="cancel()"></i>
    </div>
</div>
@if (!minimised) {

    <div class="modal-body">
        <ul class="nav nav-pills">
            <li role="presentation" [class.active]="activeTab === 0">
                <a (click)="activeTab = 0">Details</a>
            </li>
            <li role="presentation" [class.active]="activeTab === 1">
                <a (click)="activeTab = 1">Module Assign</a>
            </li>
            <li role="presentation" [class.active]="activeTab === 2">
                <a (click)="activeTab = 2">Business Assign</a>
            </li>
            <li role="presentation" [class.active]="activeTab === 3">
                <a (click)="activeTab = 3">Audit</a>
            </li>
        </ul>
        <hr>
        @if (activeTab === 0) {
<div>
            <gtw-user-details (emitEvent)="eventType($event)"></gtw-user-details>
        </div>
}
        @if (activeTab === 1) {
<div>
            <gtw-user-modules (emitEvent)="eventType($event)"></gtw-user-modules>
        </div>
}
        @if (activeTab === 2) {
<div>
            <gtw-user-business (emitEvent)="eventType($event)"></gtw-user-business>
        </div>
}
        @if (activeTab === 3) {
<div>
            <gtw-user-audit (emitEvent)="eventType($event)"></gtw-user-audit>
        </div>
}
    </div>

}
